import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import {setLogIn} from '../helpers/security';

import "./LoginViewLayout.css";

class LoginViewLayout extends Component {

  constructor(props) {
    super(props);

    this.state = {
      password: '',
      error: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {

  }

  onSubmit(e) {
    e.preventDefault();

    const {password} = this.state;
    const {history} = this.props;

    //ClearError
    this.setState({error: false});

    //Validate
    if (!(password === 'Futureofwork2030')) {
      console.log('error!');
      return this.setState({error: true});
    }

    //Save to localstorage
    setLogIn(() => history.push('?page=/page/home'));
  }

  handleChange(e) {
    this.setState({password: e.target.value, error:false});
  }

  render() {
    const {error,password} = this.state;
    return (
      <div id="fow-login-view-layout">
        <div className="fow-login-form">
          <form onSubmit={this.onSubmit}>
            <h3>Access restriction</h3>
            <p>Please enter the password to continue.</p>
            <input
              label="Password"
              type="password"
              name="password"
              value={password}
              placeholder="Enter password here..."
              onChange={this.handleChange}
            />
            <span className="fow-error">{error && <>Wrong password, please try again.</>}</span>
            <input type="submit" value="Login" />
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    hashParts: state.settings.hashParts
  };
};
const mapDispatchToProps = dispatch => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginViewLayout));
